/**
 * 实名认证弹窗 — 页面 mixin
 * 模板中需放置：<RealnameDialog :visible.sync="showRealnameDialog" @success="onRealnameSuccess" />
 */
import RealnameDialog from "./RealnameDialog.vue";
import { isRealnameVerified, realnameState } from "./realnameService";

export default {
  components: {
    RealnameDialog,
  },

  data() {
    return {
      showRealnameDialog: false,
    };
  },

  methods: {
    openRealnameDialog() {
      if (realnameState.loaded && isRealnameVerified(realnameState.status)) {
        this.$message.info("您已完成实名认证");
        return;
      }
      this.showRealnameDialog = true;
    },

    onRealnameSuccess() {
      this.$emit("realname-success");
    },
  },
};



// WEBPACK FOOTER //
// ./src/view/user/realname/realnameDialogMixin.js